import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Page from './Page';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Root from "./routes/root";
import History from "./History/History";
import StartList from "./StartList/StartList";
import JsonApi from './Api/JsonApi'
import RegisteredList from "./RegisteredList/RegisteredList";
import Registration from "./Registration/Registration";
import MyPage  from "./MyPage/MyPage";
import Invitation  from "./Pages/Invitation";
import PM  from "./Pages/PM";
import AllResults from "./History/AllResults";
import ImageArchive from "./History/ImageArchive/ImageArchive";
import LiveResults from "./LiveResults/LiveResults";
import TeamRegistration from "./Registration/TeamRegistration";

const jsonApi = new JsonApi('https://'+window.location.hostname+'/'); // https://kanallopet.dev.ateles.se/

const router = createBrowserRouter([
    {
        element: <Root jsonServer={jsonApi} />,
        children: [
            {
                path: "/",
                element: <App jsonServer={jsonApi} />,
            },
            {
                path: "inbjudan",
                element: <Invitation jsonServer={jsonApi} />,
            },
            {
                path: "anmalan",
                element: <Registration jsonServer={jsonApi} />,

            },
            {
                path: "laganmalan",
                element: <TeamRegistration jsonServer={jsonApi} />,

            },
            {
                path: "anmalda",
                element: <RegisteredList jsonServer={jsonApi} />,

            },
            {
                path: "pm",
                element: <PM jsonServer={jsonApi} />,
            },
            {
                path: "startlista",
                element: <StartList jsonServer={jsonApi} />,
            },
            {
                path: "liveresultat",
                element: <LiveResults jsonServer={jsonApi} />,
            },
            {
                path: "arrangorer",
                element: <Page title="Arrangörer & sponsorer" />,
            },
            {
                path: "bildarkiv",
                element: <ImageArchive jsonServer={jsonApi} />,
            },
            {
                path: "historik",
                element: <History jsonServer={jsonApi} />,
            },
            {
                path: "resultatlistor",
                element: <AllResults />,
            },
            {
                path: "minsida",
                element: <MyPage jsonServer={jsonApi} />,
            },
        ],
    },
],
    {
        basename: '',
    });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
        <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
